export default {
	text: "{changedBy} changed this goal's due date from {from} to {to}",
};
